<div class="container mt-5">
    <div class="row">
        <div class="col-sm-8">
            <h4>Precios</h4>
            <ul>
                <li *ngFor="let precio of precios" (click)="editarPrecio(precio)">{{precio.nombre}} id: {{precio.id}}</li>
            </ul>
        </div>

        <div class="col-sm-4">
            <h4>Agregar/Editar</h4>
            <form [formGroup]="formularioPrecio">
                <div class="form-group">
                    <label for="">Nombre</label>
                    <input formControlName="nombre" class="form-control" type="text">
                </div>

                <div class="form-group">
                    <label for="">Costo</label>
                    <input formControlName="costo" class="form-control" type="number">
                </div>

                <div class="form-group">
                    <label for="">Duracion</label>
                    <input formControlName="duracion" class="form-control" type="number">
                </div>

                <div class="form-group">
                    <label for="">Tipo Duracion</label>
                    <select formControlName="tipoDuracion" class="form-control" name="" id="">
                        <option value="1">Dia</option>
                        <option value="2">Semana</option>
                        <option value="3">Quincena</option>
                        <option value="4">Mes</option>
                        <option value="5">Año</option>
                    </select>
                </div>

                <button *ngIf="!esEditar" [disabled]="formularioPrecio.invalid" class="btn btn-primary" (click)="agregar()">Agregar</button>
                <button *ngIf="esEditar" [disabled]="formularioPrecio.invalid" class="btn btn-danger" (click)="editar()">Editar</button>
            </form>
        </div>
    </div>
</div>